import React, { useRef } from "react";
import { EditorComplex, EditorBasic } from "../editor/editor.component";
import Button from "../button/button.component";
import "./insert-question.styles.scss";
import { Question, QuestionBasic } from "../../@types/question.interface";
import Axios from "axios";

interface IProps {
    question: Question | QuestionBasic;
    handleChange: (evt: any, name: string, index?: number) => void;
    handleClick: (evt: any) => void;
    error: string | null;
}

export default function QuestionForm({
    question,
    handleChange,
    handleClick,
    error,
}: IProps) {
    const files2 = useRef<Array<File> | null>(null);
    const letters = ["A", "B", "C", "D"];

    const onImageUpload = (
        targetImgElement: HTMLImageElement,
        index: number,
        state: string,
        imageInfo: any,
        remainingFilesCount: number
    ) => {
        if (imageInfo !== null && files2.current !== null) {
            files2.current.map(async (file) => {
                const data = new FormData();
                data.append("media", file);
                data.append("description", file.name);
                const config = {
                    headers: {
                        authorization:
                            "qqeinFLhMFPFiE03EV29VQt67HxPmTA8N7W1U5MScJbWtib4KWULSLsvzIBjnTXa",
                    },
                };
                const result: any = await Axios.post(
                    "http://10.35.144.31/media-api/media/add",
                    data,
                    config
                );
                imageInfo.element.src = result.data.payload.data + "";
                imageInfo.src = result.data.payload.data + "";
            });

            // const result: any = await Axios.post(
            //     process.env.REACT_APP_DEFAULT_API + "questionquiz/uploadimgone",
            //     { image: imageInfo.src }
            // );
        }
    };

    const onImageUploadBefore = async (
        files: Array<File>,
        info: object,
        uploadHandler: Function
    ) => {
        if (files !== null && files.length !== 0) files2.current = files;
    };

    return (
        <div className="question-form">
            <form className="question-form__form" action="#" method="post">
                <div className="question-form__form__input">
                    <div className="question-form__form__input__label">
                        <span>Question Type</span>
                    </div>
                    <select
                        className="question-form__form__input__select"
                        onChange={(evt) =>
                            handleChange(evt, "question_type_id")
                        }
                        defaultValue="-"
                    >
                        <option value="-" disabled>
                            Select Question Type
                        </option>
                        <option value="1">Single Answer</option>
                        <option value="2">Multiple Answer</option>
                    </select>
                </div>
                <div className="question-form__form__input">
                    <div className="question-form__form__input__label">
                        <span>Question</span>
                    </div>
                    <div className="question-form__form__input__editor">
                        <EditorComplex
                            onChange={(evt: any) =>
                                handleChange(evt, "question_quiz")
                            }
                            onImageUpload={onImageUpload}
                            onImageUploadBefore={onImageUploadBefore}
                        />
                    </div>
                </div>
                {letters.map((letter, index) => {
                    return (
                        <div key={index} className="question-form__form__input">
                            <div className="question-form__form__input__label">
                                <span>Answer for {letter}</span>
                            </div>
                            <div className="question-form__form__input__editor">
                                <EditorBasic
                                    onChange={(evt: any) =>
                                        handleChange(
                                            evt,
                                            "question_choice",
                                            index
                                        )
                                    }
                                    onImageUploadBefore={onImageUploadBefore}
                                />
                            </div>
                        </div>
                    );
                })}
                {question.question_type_id === 1 ? (
                    <div className="question-form__form__input">
                        <div className="question-form__form__input__label">
                            <span>Question Answer</span>
                        </div>
                        {letters.map((answer, index) => {
                            return (
                                <div
                                    key={index}
                                    className="question-form__form__input__answer"
                                >
                                    <input
                                        className="question-form__form__input__answer__radio"
                                        type="radio"
                                        value={answer}
                                        name="question_answer"
                                        onChange={(evt) =>
                                            handleChange(
                                                evt,
                                                "question_answer",
                                                0
                                            )
                                        }
                                    />
                                    <div className="question-form__form__input__answer__value">
                                        <span>{answer}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : question.question_type_id === 2 ? (
                    <div className="question-form__form__input">
                        <div className="question-form__form__input__label">
                            <span>Question Answer</span>
                        </div>
                        {letters.map((answer, index) => {
                            return (
                                <div
                                    key={index}
                                    className="question-form__form__input__answer"
                                >
                                    <input
                                        className="question-form__form__input__answer__checkbox"
                                        type="checkbox"
                                        value={answer}
                                        onChange={(evt) =>
                                            handleChange(
                                                evt,
                                                "question_answer",
                                                index
                                            )
                                        }
                                    />
                                    <div className="question-form__form__input__answer__value">
                                        <span>{answer}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    ""
                )}
                <div className="question-form__form__input">
                    <div className="question-form__form__input__label">
                        <span>Question Score</span>
                    </div>
                    <input
                        className="question-form__form__input__number"
                        type="number"
                        placeholder="0"
                        onChange={(evt) => handleChange(evt, "weight_score")}
                    />
                </div>
                <div className="question-form__form__input">
                    <div className="question-form__form__input__label">
                        <span>Reason For This Answer</span>
                    </div>
                    <EditorComplex
                            onChange={(evt: any) =>
                                handleChange(evt, "reason_answer")
                            }
                            onImageUpload={onImageUpload}
                            onImageUploadBefore={onImageUploadBefore}
                        />
                </div>
                {error ? (
                    <div className="question-form__form__error error">
                        {error}
                    </div>
                ) : (
                    ""
                )}
                <div className="question-form__form__button">
                    <Button
                        className="dark"
                        onClick={(evt) => handleClick(evt)}
                        type="submit"
                    >
                        Insert Question
                    </Button>
                </div>
            </form>
        </div>
    );
}
